import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { Observable, finalize } from 'rxjs';
import { LoaderService } from '../services/loader.service';

@Injectable()
export class loaderInterceptor implements HttpInterceptor {
  constructor(
    @Inject('LOADER_ON_HTTP') private loaderOnHttp: string,
    private loaderService: LoaderService
  ) { }

  intercept(
    req: HttpRequest<unknown>,
    handler: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (this.loaderOnHttp && !req.headers.has('x-validate-only') && !req.url.includes('/assets/') && !req.url.includes('lokalise')) {
      this.loaderService.showLoader();
      return handler
        .handle(req)
        .pipe(finalize(() => this.loaderService.hideLoader()));
    }

    return handler.handle(req);
  }
}
